import { Button, Flex } from 'antd';
import { useTranslation } from 'react-i18next';

import { LOGIN } from '@/constants/routes';
import ErrorState from '@/UI/ErrorState/ErrorState';
import { clearAuthSessionStorage } from '@/utils/localStorage';

const Error = () => {
  const [t] = useTranslation();

  const goToLogin = () => {
    clearAuthSessionStorage();
    window.location.assign(LOGIN);
  };

  return (
    <ErrorState
      fullPage
      title={t('ERROR_MESSAGE')}
      action={
        <Flex gap="small" wrap="wrap" justify="center">
          <Button onClick={() => window.location.reload()}>
            {t('RELOAD_PAGE')}
          </Button>
          <Button type="primary" onClick={goToLogin}>
            {t('ERROR_BACK_TO_LOGIN')}
          </Button>
        </Flex>
      }
    />
  );
};

export default Error;
